import "ngstorage";

import {REFERENCE_SCREENS} from "../../variables";

class QuestionfourController {
  constructor($localStorage, $rootScope, $scope, $state, $stateParams, AuthService, EnvService, SecurityService, $timeout, TrackingService, events) {
    this.name = "questionfour";
    //this.walkthroughState = WALKTHROUGH_STATES.ARRIVAL_INSTRUCTIONS;

    this.$localStorage = $localStorage;
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$auth = AuthService;
    this.$env = EnvService;
    this.$security = SecurityService;
    this.$timeout = $timeout;
    this.$tracking = TrackingService;
    this.$events = events;
    this.referenceScreens = REFERENCE_SCREENS;
    this.disableButton = true;
  }

  $onInit() {}

  goNext() {
    this.$timeout(() => {
      this.$rootScope.$emit("SendToNextReferenceScreen", {
        referenceScreen: this.referenceScreens.QUESTION_FOUR,
      });
    });
  }

  setActiveElement(eleNum) {
    this.answer = eleNum;

    let activeEl = ".rating-wrapper ul li.active";
    let el = ".rating-wrapper ul li:nth-child(" + eleNum + ")";

    if ($(activeEl).length >= 1) {
      this.$timeout(() => {
        $(activeEl).removeClass("active");
      });
    }

    this.$timeout(() => {
      $(el).addClass("active");
    });

    this.disableButton = false;
  }

  saveAnswer() {

    let data = {};

    this.setLoader();
    data.questionId = this.determineReferenceTypeAndReturnProoperQuestionId();
    data.answer = this.answer;
    data.userReferenceId = this.event.rid;

    this.$security.saveReferenceQuestion(data).then(
      (response) => {
        this.unSetLoader();
        this.goNext();
      },
      (error) => {
        this.unSetLoader();
        alert("error saving answer");
      }
    );
  }

  determineReferenceTypeAndReturnProoperQuestionId() {

    let result;

    if (this.event.referenceType === "PROFESSIONAL") {
      result = this.$security.findQuestionId("Rate their reliability, 5 being you think they are extremely reliable", this.event.questions);
    } else {
      result = this.$security.findQuestionId("timeliness", this.event.questions);
    }

    return result;

  }

  setLoader() {
    this.$timeout(() => {
      $("html").addClass("wait");
    });
  }

  unSetLoader() {
    this.$timeout(() => {
      $("html").removeClass("wait");
    });
  }

}

QuestionfourController.$inject = [
  "$localStorage",
  "$rootScope",
  "$scope",
  "$state",
  "$stateParams",
  "auth",
  "env",
  "security",
  "$timeout",
  "tracking",
  "events",
];

export default QuestionfourController;



// WEBPACK FOOTER //
// ./client/app/scenes/references/scenes/questionfour/questionfour.controller.js